import { BuildType, Environment, OperatingSystemName, ScreenOrientation, } from '../../../protos/squareup/unifiedeventing/messages/context';
import { Environments } from '../enums';
export function convertContext(context, environment) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        device: {
            screen_orientation: ScreenOrientation.UNKNOWN_SCREEN_ORIENTATION,
            is_tablet: false,
        },
        network: {
            type: context.network.type,
            ip_address: context.network.ipAddress,
        },
        library: context.library,
        geo: {
            country_code: context.locale.countryCode,
            language: context.locale.language,
            latitude: 0, // CDPINFRA-3741
            longitude: 0, // CDPINFRA-3741
        },
        os: {
            name: getOsName(context.os.name),
            public_version: (_a = context.os.version) !== null && _a !== void 0 ? _a : '',
            build_id: '',
            incremental_version: '',
            security_version: '',
        },
        app: {
            registry_name: (_c = (_b = context.application) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
            public_version: (_e = (_d = context.application) === null || _d === void 0 ? void 0 : _d.version) !== null && _e !== void 0 ? _e : '',
            build_type: BuildType.UNKNOWN_BUILD_TYPE,
            browser_name: (_f = context.browser.name) !== null && _f !== void 0 ? _f : '',
            browser_version: (_g = context.browser.version) !== null && _g !== void 0 ? _g : '',
            height_px: context.browser.height,
            width_px: context.browser.width,
            environment: getEnvironment(environment),
            is_super_pos: false,
            user_agent: context.userAgent,
        },
        subject: {
            person_token: (_h = context.subject.personToken) !== null && _h !== void 0 ? _h : '',
            merchant_token: (_j = context.subject.merchantToken) !== null && _j !== void 0 ? _j : '',
            anonymous_token: (_k = context.subject.anonymousToken) !== null && _k !== void 0 ? _k : '',
            unit_token: (_l = context.subject.unitToken) !== null && _l !== void 0 ? _l : '',
            employment_token: (_m = context.subject.employmentToken) !== null && _m !== void 0 ? _m : '',
            credential_token: (_o = context.subject.credentialToken) !== null && _o !== void 0 ? _o : '',
        },
        session: {
            token: context.session.token,
            start_time_millis: context.session.startTimeMillis,
        },
        page: {
            path: context.page.path,
            referrer: context.page.referrer,
            search: context.page.search,
            title: context.page.title,
            url: context.page.url,
        },
    };
}
export function getEnvironment(env) {
    switch (env) {
        case Environments.stage: {
            return Environment.STAGING;
        }
        case Environments.production: {
            return Environment.PRODUCTION;
        }
        default: {
            return Environment.OTHER;
        }
    }
}
export function getOsName(osName) {
    switch (osName) {
        case 'Android': {
            return OperatingSystemName.ANDROID_WEB;
        }
        case 'iOS': {
            return OperatingSystemName.IOS_WEB;
        }
        case 'Windows': {
            return OperatingSystemName.WINDOWS;
        }
        case 'Mac OS': {
            return OperatingSystemName.MAC_OS;
        }
        case 'Linux':
        case 'Ubuntu':
        case 'Fedora':
        case 'Arch':
        case 'Debian':
        case 'CentOS':
        case 'Mint':
        case 'RedHat':
        case 'VectorLinux': {
            return OperatingSystemName.LINUX;
        }
        default: {
            return OperatingSystemName.UNKNOWN_OS;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1jb250ZXh0LXNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvY29udGV4dC9tYWtlLWNvbnRleHQtc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxTQUFTLEVBRVQsV0FBVyxFQUNYLG1CQUFtQixFQUNuQixpQkFBaUIsR0FDbEIsTUFBTSwyREFBMkQsQ0FBQztBQUNuRSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBR3hDLE1BQU0sVUFBVSxjQUFjLENBQzVCLE9BQXNCLEVBQ3RCLFdBQXlCOztJQUV6QixPQUFPO1FBQ0wsTUFBTSxFQUFFO1lBQ04sa0JBQWtCLEVBQUUsaUJBQWlCLENBQUMsMEJBQTBCO1lBQ2hFLFNBQVMsRUFBRSxLQUFLO1NBQ2pCO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsSUFBSSxFQUFFLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSTtZQUMxQixVQUFVLEVBQUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTO1NBQ3RDO1FBQ0QsT0FBTyxFQUFFLE9BQU8sQ0FBQyxPQUFPO1FBQ3hCLEdBQUcsRUFBRTtZQUNILFlBQVksRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLFdBQVc7WUFDeEMsUUFBUSxFQUFFLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUTtZQUNqQyxRQUFRLEVBQUUsQ0FBQyxFQUFFLGdCQUFnQjtZQUM3QixTQUFTLEVBQUUsQ0FBQyxFQUFFLGdCQUFnQjtTQUMvQjtRQUNELEVBQUUsRUFBRTtZQUNGLElBQUksRUFBRSxTQUFTLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUM7WUFDaEMsY0FBYyxFQUFFLE1BQUEsT0FBTyxDQUFDLEVBQUUsQ0FBQyxPQUFPLG1DQUFJLEVBQUU7WUFDeEMsUUFBUSxFQUFFLEVBQUU7WUFDWixtQkFBbUIsRUFBRSxFQUFFO1lBQ3ZCLGdCQUFnQixFQUFFLEVBQUU7U0FDckI7UUFDRCxHQUFHLEVBQUU7WUFDSCxhQUFhLEVBQUUsTUFBQSxNQUFBLE9BQU8sQ0FBQyxXQUFXLDBDQUFFLElBQUksbUNBQUksRUFBRTtZQUM5QyxjQUFjLEVBQUUsTUFBQSxNQUFBLE9BQU8sQ0FBQyxXQUFXLDBDQUFFLE9BQU8sbUNBQUksRUFBRTtZQUNsRCxVQUFVLEVBQUUsU0FBUyxDQUFDLGtCQUFrQjtZQUN4QyxZQUFZLEVBQUUsTUFBQSxPQUFPLENBQUMsT0FBTyxDQUFDLElBQUksbUNBQUksRUFBRTtZQUN4QyxlQUFlLEVBQUUsTUFBQSxPQUFPLENBQUMsT0FBTyxDQUFDLE9BQU8sbUNBQUksRUFBRTtZQUM5QyxTQUFTLEVBQUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxNQUFNO1lBQ2pDLFFBQVEsRUFBRSxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUs7WUFDL0IsV0FBVyxFQUFFLGNBQWMsQ0FBQyxXQUFXLENBQUM7WUFDeEMsWUFBWSxFQUFFLEtBQUs7WUFDbkIsVUFBVSxFQUFFLE9BQU8sQ0FBQyxTQUFTO1NBQzlCO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsWUFBWSxFQUFFLE1BQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFzQixtQ0FBSSxFQUFFO1lBQzNELGNBQWMsRUFBRSxNQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsYUFBd0IsbUNBQUksRUFBRTtZQUMvRCxlQUFlLEVBQUUsTUFBQyxPQUFPLENBQUMsT0FBTyxDQUFDLGNBQXlCLG1DQUFJLEVBQUU7WUFDakUsVUFBVSxFQUFFLE1BQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFvQixtQ0FBSSxFQUFFO1lBQ3ZELGdCQUFnQixFQUFFLE1BQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxlQUEwQixtQ0FBSSxFQUFFO1lBQ25FLGdCQUFnQixFQUFFLE1BQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxlQUEwQixtQ0FBSSxFQUFFO1NBQ3BFO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFLE9BQU8sQ0FBQyxPQUFPLENBQUMsS0FBSztZQUM1QixpQkFBaUIsRUFBRSxPQUFPLENBQUMsT0FBTyxDQUFDLGVBQWU7U0FDbkQ7UUFDRCxJQUFJLEVBQUU7WUFDSixJQUFJLEVBQUUsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJO1lBQ3ZCLFFBQVEsRUFBRSxPQUFPLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFDL0IsTUFBTSxFQUFFLE9BQU8sQ0FBQyxJQUFJLENBQUMsTUFBTTtZQUMzQixLQUFLLEVBQUUsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLO1lBQ3pCLEdBQUcsRUFBRSxPQUFPLENBQUMsSUFBSSxDQUFDLEdBQUc7U0FDdEI7S0FDRixDQUFDO0FBQ0osQ0FBQztBQUVELE1BQU0sVUFBVSxjQUFjLENBQUMsR0FBaUI7SUFDOUMsUUFBUSxHQUFHLEVBQUUsQ0FBQztRQUNaLEtBQUssWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDeEIsT0FBTyxXQUFXLENBQUMsT0FBTyxDQUFDO1FBQzdCLENBQUM7UUFDRCxLQUFLLFlBQVksQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO1lBQzdCLE9BQU8sV0FBVyxDQUFDLFVBQVUsQ0FBQztRQUNoQyxDQUFDO1FBQ0QsT0FBTyxDQUFDLENBQUMsQ0FBQztZQUNSLE9BQU8sV0FBVyxDQUFDLEtBQUssQ0FBQztRQUMzQixDQUFDO0lBQ0gsQ0FBQztBQUNILENBQUM7QUFFRCxNQUFNLFVBQVUsU0FBUyxDQUFDLE1BQTBCO0lBQ2xELFFBQVEsTUFBTSxFQUFFLENBQUM7UUFDZixLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7WUFDZixPQUFPLG1CQUFtQixDQUFDLFdBQVcsQ0FBQztRQUN6QyxDQUFDO1FBQ0QsS0FBSyxLQUFLLENBQUMsQ0FBQyxDQUFDO1lBQ1gsT0FBTyxtQkFBbUIsQ0FBQyxPQUFPLENBQUM7UUFDckMsQ0FBQztRQUNELEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztZQUNmLE9BQU8sbUJBQW1CLENBQUMsT0FBTyxDQUFDO1FBQ3JDLENBQUM7UUFDRCxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUM7WUFDZCxPQUFPLG1CQUFtQixDQUFDLE1BQU0sQ0FBQztRQUNwQyxDQUFDO1FBQ0QsS0FBSyxPQUFPLENBQUM7UUFDYixLQUFLLFFBQVEsQ0FBQztRQUNkLEtBQUssUUFBUSxDQUFDO1FBQ2QsS0FBSyxNQUFNLENBQUM7UUFDWixLQUFLLFFBQVEsQ0FBQztRQUNkLEtBQUssUUFBUSxDQUFDO1FBQ2QsS0FBSyxNQUFNLENBQUM7UUFDWixLQUFLLFFBQVEsQ0FBQztRQUNkLEtBQUssYUFBYSxDQUFDLENBQUMsQ0FBQztZQUNuQixPQUFPLG1CQUFtQixDQUFDLEtBQUssQ0FBQztRQUNuQyxDQUFDO1FBQ0QsT0FBTyxDQUFDLENBQUMsQ0FBQztZQUNSLE9BQU8sbUJBQW1CLENBQUMsVUFBVSxDQUFDO1FBQ3hDLENBQUM7SUFDSCxDQUFDO0FBQ0gsQ0FBQyJ9